import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIALS } from '../utils/constants';
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 bg-gray-50 px-4" data-id="element-238">
      <div className="max-w-6xl mx-auto" data-id="element-239">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-stone-900 mb-12" data-id="element-240">
          Cosa stanno dicendo altri insegnanti di tango
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
          {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col" data-id="element-242">
              <div className="flex space-x-1 mb-4" data-id="element-243">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-244" />)}
              </div>
              <p className="text-stone-700 italic mb-6 flex-1" data-id="element-245">
                "{testimonial.review}"
              </p>
              <div className="border-t border-gray-100 pt-4 mt-auto" data-id="element-246">
                <p className="font-bold text-stone-900" data-id="element-247">{testimonial.name}</p>
                <p className="text-sm text-gray-500" data-id="element-248">
                  {testimonial.age} anni – {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}